<app-spinner name="remove-emp-role"></app-spinner>
<div>
  @if (showErrorMessage) {
    <app-alert [message]="showErrorMessage" [msgtype]="'error'" [messageHeading]="'Error'"></app-alert>
  }
</div>

@if (!isRequestSuccess) {
  <div>
    <app-multi-org-filter-ta pageType="remove-employee-role" [showRequired]="true" [showSelectRoles]="true" [isRoleAdmin]="true"></app-multi-org-filter-ta>
    <div class="mtb-20">
      <h3>
        Remove Employee Role
      </h3>
    </div>
    <div class="mtb-20 gap-20 flex" *ngIf="isDewOrg && hasProfileAdmin">
      <div class="lrg flex align-center">
        <input type="checkbox" id="dewStaff" name="dewStaff" [(ngModel)]="isDewStaff" (change)="onDewStaffChange($event)">
        <label class="ml-10" for="dewStaff">DEW Staff Members</label>
      </div>
    </div>
    <div class="fade">
      <div class="inline-text-field-container even-cols flex-row gap-20 mb-20">
        <ng-select class="custom" placeholder="*Search Employee" name="selectedEmployee" [(ngModel)]="selectedEmployee"
          [items]="employees$ | async" [typeahead]="search$" [loading]="loading" [clearable]="true" (clear)="onClear()"
          [hideSelected]="true" placeholder="*Search Employee" (change)="onEmployeeSelect($event)">
          <ng-template ng-label-tmp let-item="item" let-index="index">
            <span class="ng-value-label">{{item?.firstName + " "+ item?.lastName + (item?.emailAddress ? (" - " + item?.emailAddress) : '')}}</span>
          </ng-template>
          <ng-template ng-option-tmp let-item="item" let-index="index">
            <span class="ng-value-label">{{item?.firstName + " "+ item?.lastName + (item?.emailAddress ? (" - " + item?.emailAddress) : '')}}</span>
          </ng-template>
        </ng-select>
        <div></div>
      </div>
    </div>
    <div class=" mb-30">
      <div class="card fluid ">
        <div class="card__content border-bottom border-gray-600">
          <div class="width-full">
            <div class="bold">
              Existing Role Information
            </div>
            <div class="mtb-10">
              Below is a list of roles associated with the employee search result. You can
              remove the role from this employee by selecting the check boxes below and
              submitting your choices by clicking the
              "Submit Role Removal Request" button at the bottom of the page.
            </div>
            @if (userRoles?.length) {
              <div class="flex gap-30 to-block width-full mb-20 pb-10">
                <div class="basis-50">
                  <div>
                    <ul class="requests-legend">
                      <li>
                        <div class="display-inline-block">
                          <div>
                            <i class="fa-solid fa-trash"></i>
                          </div>
                          <div  class="font-gray-700">
                            <b>Role</b>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div>
                    <ul class="role-checkbox"
                      style="display: flex; flex-direction: column;  overflow: auto;max-height: 500px;">
                      @for (role of userRoles; track role; let i = $index) {
                        <li class="relative">
                          <div class="lrg">
                            <input type="checkbox" [id]="'roleSelect'+i" [name]="'roleSelect'+i"
                              [value]="role.role.key" [checked]="isSelected(role)"
                              (change)="onRoleCheckBoxChage($event, role)">
                              <label class="ml-10" for="role1">{{role.role.name}}</label>
                            </div>
                            @if (isSelected(role)) {
                              <div class="inline-text-field-container fade">
                                <div class="mb-5"><span style="color: red;font-size: 24px;">*</span>Reason for Removing the role.</div>
                                <div class="text-area-container">
                                  <label for="address2"
                                  class="ds-floating-label text-area">Please add reason to Remove Role</label>
                                  <textarea class="textarea" name="subject" required rows="3"
                                  [(ngModel)]="role.reason"></textarea>
                                </div>
                              </div>
                            }
                          </li>
                        }
                      </ul>
                    </div>
                  </div>
                  <div class="basis-50">
                    <div>
                      <b>Responsibilities</b>
                    </div>
                    <div class="mt-20">
                      <div class="mt-10 responsibility" style="display: flex; flex-direction: column; overflow: auto; max-height: 500px;">
                        @for (userRole of selectedRoles; track userRole) {
                          <div class="mb-10">
                            <b>{{userRole.role.name}}</b>
                          </div>
                          @for(roleResponsibility of userRole.roleResponsibilities; track roleResponsibility) {
                              <ul>
                                <div>
                                  <b>{{roleResponsibility.systemName}}</b>
                                </div>
                                @for(responsibility of roleResponsibility.roleResponsibility; track responsibility) {
                                  <li class="pl-0">
                                    {{responsibility}}
                                  </li>
                                }
                              </ul>
                            }
                        }
                      </div>
                    </div>
                  </div>
                </div>
              }
              @if (!userRoles?.length) {
                <div class="width-full">
                  <div class="flex justify-center">
                    <div class="mtb-20">
                      <b>No roles found</b>
                    </div>
                  </div>
                </div>
              }
              <div class="mt-20">
                <div class="container flex mobile border-top border-gray-600 mt-20 pt-10">
                  <span class="basis-50">
                    <span class="flex justify-start">
                      @if (selectedRoles?.length > 0) {
                        <button class="rounded-4 hover-blue-800 black mobile" (click)="addRolesToCart()">
                          <div class="btn-txt font-white bold">
                            *Add Role(s) to Removal
                          Cart</div>
                        </button>
                      }
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <app-role-request-cart [rolesOnCart]="rolesOnCart" (removeRole)="removeRole($event)"></app-role-request-cart>
      <div class="container flex mobile border-top border-gray-600 mt-20 pt-10">
        <span class="basis-50">
          <span class="flex justify-start">
            <button [routerLink]="['..']"
              class="secondary border-red rounded-4 hover-red hover-font-white flex-row-reverse mobile">
              <div class="btn-txt font-red bold">Back</div>
            </button>
          </span>
        </span>
        <span class="basis-50">
          <span class="flex justify-end">
            <button class="rounded-4 hover-blue-800 black mobile" [class.disabled]="!rolesOnCart?.length"
              (click)="submitRoleRequest()">
              <div class="btn-txt font-white bold">Submit Role Removal Request</div>
            </button>
          </span>
        </span>
      </div>
    </div>
  }

  @if (isRequestSuccess) {
    <app-role-request-success message="Your role removal request has been processed."></app-role-request-success>
  }
